import React from 'react';
import {t} from '@lingui/core/macro';

import Tabs, {ITabItem} from 'shared/ui/Tabs/Tabs';
import {HTTP_MONITOR_TABS, HttpMonitorTab} from 'features/http/lib/httpMonitorDetailsScreen';

import styles from './HttpMonitorTabs.module.scss';

interface IHttpMonitorTabsProps {
    activeTab: HttpMonitorTab;
    // eslint-disable-next-line no-unused-vars
    onTabChange: (tab: HttpMonitorTab) => void;
}

const HttpMonitorTabs: React.FC<IHttpMonitorTabsProps> = ({ activeTab, onTabChange }) => {
    const labels: Record<HttpMonitorTab, string> = {
        incidents: t`Инциденты`,
        logs: t`Журнал`,
    };

    const items: ITabItem<HttpMonitorTab>[] = HTTP_MONITOR_TABS.map((tab) => ({
        id: tab,
        label: labels[tab],
    }));

    return (
        <Tabs
            items={items}
            activeId={activeTab}
            onChange={onTabChange}
            className={styles.tabs}
        />
    );
};

export default HttpMonitorTabs;
